<template>
   
    <div class="selected-record drop-shadow">
        <div class="inner">
            <div class="title">
            <h4>Upload CV for:</h4>
            <hr/>
            </div>
            <div class="row">
                <div class="lhs">
                    <div class="data">
                        <div class="label">{{record.brandedPublicId}}</div>
                        <div class="value">{{record.forename}} {{record.surname}}</div>
                    </div>
                </div>
                <div class="rhs">
                    <div class="data">
                        <div class="label">{{record.country}}</div>
                        <div class="value">{{record.city}}</div>
                    </div>
                </div>
            </div>
            
            <div class="row">
                <div class="full">
                    <div class="single-button" >
                        <a :href="sfLink" target="_blank" class="button">View in Salesforce</a>
                    </div>
                </div>
            </div>
        </div>


    </div>    
                
</template>

<script>
    export default {
        name: 'LinkedRecord',
        props: [
            'record'
        ],
        computed: {
            externalId() {
                return this.$route.query.externalId != '' ? this.$route.query.externalId : null;
            },
            environment() {
                return this.$store.state.app.environment || '';
            },
            theme() {
                return this.$store.state.user.theme || '';
            },
            sfLink() {
                let url = this.environment;
                if (this.theme === 'lightning') {
                   url += '/lightning/r/Contact/' + this.externalId + '/view?0.source=alohaHeader';
                }  else {
                   url += '/apex/ContactView?id=' + this.externalId;
                }
                return url;
            }
        },
    }
</script>

<style scoped>
    
     .selected-record {margin-bottom: 1.5rem; background-color: #fff; /*background: var(--colour-primary); border: solid .1rem var(--colour-primary-dark); color: #fff; text-shadow: 0.05rem 0.05rem 0.1rem #000000;*/}
        .selected-record .inner {width: 100%;}
        .selected-record .title {padding: 1rem 1rem 0rem 1rem;}
            .selected-record .title hr {margin: 1rem 0;}
        .selected-record .row {padding: 0rem 1rem 1rem 1rem; display: flex; flex-wrap: wrap;}
            .selected-record .row .lhs {flex-grow: 1; margin-top: auto;}
            .selected-record .row .rhs {flex-grow: 1; text-align: right; margin-top: auto;}
            .selected-record .row .full {flex-grow: 1; margin-top: auto;}
        .selected-record .data-small {font-size: .8rem;}
        .selected-record .data-small + .data-small {margin-top: .25rem;}
    
        .selected-record .data + .data {margin-top: 1rem;}
            .selected-record .data .label {font-size: .7rem; font-weight: bold; text-transform: uppercase; display: table; word-break: break-word; width: 100%;}
            .selected-record .data .value {font-family: 'Roboto Condensed', sans-serif; font-size: 1.25rem; font-weight: bold; display: table; word-break: break-word; width: 100%;}

            .selected-record .single-button .button {width: 100%; box-sizing: border-box;}
            

        @media screen and (max-width: 550px) {
            .selected-record > .row .lhs, .duplicate > .row .rhs {width: 100%; text-align: left;}
            .selected-record > .row .lhs {padding-bottom: 1rem;}
            .selected-record .buttons {text-align: right;}
        }

    
</style>